import { useEffect } from 'react'
import { useRolloverTodos } from '../api/hooks'

/**
 * Returns today's date in the user's local timezone as YYYY-MM-DD.
 * We use local (not UTC) so the day boundary matches what the user sees in
 * the weekly grid. A user in IST opening the app at 00:30 local should get
 * the same "today" the grid shows them, not yesterday-in-UTC.
 */
function localToday(): string {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const STORAGE_KEY = 'todux:rollover:lastRun'

/**
 * Fires the daily rollover at most once per local day, per device.
 *
 * The server has its own row-locked gate, so even if the client check fails
 * to dedupe (cleared storage, second device, etc.) the server will still
 * no-op the second call. The client-side gate is purely an optimization to
 * skip the network round-trip on every WeeklyGrid mount.
 *
 * Mount this hook once near the top of the weekly view.
 */
export function useDailyRollover(): void {
  const { mutate } = useRolloverTodos()

  useEffect(() => {
    const today = localToday()
    if (localStorage.getItem(STORAGE_KEY) === today) return
    mutate(
      { today },
      {
        onSuccess: () => localStorage.setItem(STORAGE_KEY, today),
      },
    )
  }, [mutate])
}
